var _circle, _path, _path2, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 21,
    fill: "#FFB649",
    fillOpacity: 0.2,
    stroke: "#FFB649",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 37V23C21 22.4696 21.2107 21.9609 21.5858 21.5858C21.9609 21.2107 22.4696 21 23 21H34.172C34.7024 21.0001 35.211 21.2109 35.586 21.586L38.414 24.414C38.7891 24.789 38.9999 25.2976 39 25.828V37C39 37.5304 38.7893 38.0391 38.4142 38.4142C38.0391 38.7893 37.5304 39 37 39H23C22.4696 39 21.9609 38.7893 21.5858 38.4142C21.2107 38.0391 21 37.5304 21 37Z",
    stroke: "#FFB649",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 27H33.4C33.5591 27 33.7117 26.9368 33.8243 26.8243C33.9368 26.7117 34 26.5591 34 26.4V21.6C34 21.4409 33.9368 21.2883 33.8243 21.1757C33.7117 21.0632 33.5591 21 33.4 21H26.6C26.4409 21 26.2883 21.0632 26.1757 21.1757C26.0632 21.2883 26 21.4409 26 21.6V26.4C26 26.5591 26.0632 26.7117 26.1757 26.8243C26.2883 26.9368 26.4409 27 26.6 27ZM24 31.6V39H36V31.6C36 31.4409 35.9368 31.2883 35.8243 31.1757C35.7117 31.0632 35.5591 31 35.4 31H24.6C24.4409 31 24.2883 31.0632 24.1757 31.1757C24.0632 31.2883 24 31.4409 24 31.6Z",
    stroke: "#FFB649",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 4.5,
    fill: "#FFB649",
    fillOpacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 8,
    r: 3,
    fill: "#FFB649",
    fillOpacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 52,
    r: 2,
    fill: "#FFB649",
    fillOpacity: 0.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 14,
    r: 2,
    fill: "#FFB649",
    fillOpacity: 0.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.40e3ec0ddfb596cdcdf7bf638c353683.svg";
export { ForwardRef as ReactComponent };